import { useLocation, useNavigate } from "react-router-dom";
import { MobileSideBarItem, MobileSideBarWrapper } from "./style/mobileLayout";
export interface IMenuItem {
  name: string;
  path: string[];
  icon: string;
}
export const MENU: IMenuItem[] = [
  {
    name: "토너먼트",
    path: ["/tournament", "/"],
    icon: "tournament.svg",
  },
  {
    name: "정산",
    path: ["/solution"],
    icon: "solution.svg",
  },
  {
    name: "회원관리",
    path: ["/member"],
    icon: "member.svg",
  },
];
const MobileSideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isPathMatch = (path: string, pathname: string) => {
    const basePath = pathname.split("/")[1];
    return path === "/" + basePath;
  };

  return (
    <MobileSideBarWrapper>
      {MENU.map((item, index) => (
        <MobileSideBarItem
          key={index}
          onClick={() => navigate(item.path[0])}
          isSelected={item.path.some(
            (path) =>
              isPathMatch(path, location.pathname) ||
              (path !== "/" && location.pathname.startsWith(path))
          )}
        >
          <div className="icon-back">
            <img
              src={`/image-web/menu/${item.icon}`}
              style={{
                filter: item.path.some(
                  (path) =>
                    isPathMatch(path, location.pathname) ||
                    (path !== "/" && location.pathname.startsWith(path))
                )
                  ? "invert(74%) sepia(0%) saturate(2132%) hue-rotate(15deg) brightness(84%) contrast(98%)"
                  : "invert(21%) sepia(1%) saturate(1817%) hue-rotate(5deg) brightness(89%) contrast(91%)",
              }}
              alt="menu icon"
            />
          </div>
          <div className="title">{item.name}</div>
        </MobileSideBarItem>
      ))}
    </MobileSideBarWrapper>
  );
};
export default MobileSideBar;
